import { createAction } from "redux-act";

export const OpenPlaygroundSettingsModalAction = createAction("Playground Settings - Open Modal");
export const ClosePlaygroundSettingsModalAction = createAction("Playground Settings - Close Modal");
